/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A navigation solution for VDK Web. (@accedo/vdkweb-navigation) 6.2.6
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _navigationService = _interopRequireDefault(require("../navigationService"));
var _uiImplementationHelpers = require("../uiImplementationHelpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var NOOP = function NOOP() {};
var withFocusDOM = function withFocusDOM(_ref) {
  var directionReassign = _ref.directionReassign,
    domEl = _ref.domEl,
    nav = _ref.nav,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? NOOP : _ref$onBlur,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? NOOP : _ref$onFocus,
    _ref$onUpdate = _ref.onUpdate,
    onUpdate = _ref$onUpdate === void 0 ? NOOP : _ref$onUpdate;
  var lastFocus = null;
  var onClick = function onClick() {
    domEl.click();
  };
  var fn = function fn(newData, prevData) {
    (0, _uiImplementationHelpers.handleNavigationUpdate)({
      directionReassign: directionReassign,
      getLastFocus: function getLastFocus() {
        return lastFocus;
      },
      nav: nav,
      newData: newData,
      onBlur: onBlur,
      onClick: onClick,
      onFocus: onFocus,
      onUpdate: onUpdate,
      prevData: prevData,
      setLastFocus: function setLastFocus(v) {
        lastFocus = v;
      }
    });
  };
  var unlisten = _navigationService["default"].listenToFocusEvent({
    id: nav.id,
    fn: fn
  });
  (0, _uiImplementationHelpers.forwardFocusIfNecessary)({
    nav: nav
  });
  return unlisten;
};
var _default = withFocusDOM;
exports["default"] = _default;